import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  loadingMessage : string
  constructor(private dataService : DataService) { }

  ngOnInit(): void {
    this.loadingMessage = this.dataService.loadingMessage
  }

}
